export default __webpack_public_path__ + "static/2-8b4b423795a5a2cd84a9821526e02e63.jpg";